import { isEmpty } from "lodash";
import { useMemo } from "react";
import {
  ArbitrageOrderBooks,
  InfoValuesType,
} from "src/Modules/Arbitrage/types";
import { ExchangePrice } from "./ExchangePrice";

export const ExchangeDetailCell = ({
  rowData,
  valueType,
  cellIndex,
}: {
  rowData: ArbitrageOrderBooks;
  valueType: InfoValuesType;
  cellIndex: number;
}) => {
  const values = rowData[valueType];
  const currentValue = useMemo(
    () => values[cellIndex - 1],
    [values, cellIndex]
  );

  if (isEmpty(currentValue))
    return (
      <div style={{ textAlign: "center", width: "100%", color: "#888888" }}>
        --
      </div>
    );

  return (
    <ExchangePrice
      cryptoName={rowData.name}
      cryptoSymbol={rowData.symbol}
      valueType={valueType}
      {...currentValue}
    />
  );
};
